import { readFirstSheet } from '@/utils/previewSheet';
import { decodePreviewText, parseDelimitedTable } from '@/utils/previewText';

export type PreviewBody =
  | { kind: 'text'; text: string; truncated: boolean }
  | {
      kind: 'table';
      title: string | null;
      sheetCount: number;
      rows: string[][];
      truncated: boolean;
      excelRows?: number[];
    };

export async function readPreviewBody(
  kind: 'text' | 'csv' | 'sheet',
  bytes: ArrayBuffer,
): Promise<PreviewBody> {
  switch (kind) {
    case 'text': {
      const decoded = decodePreviewText(bytes);
      return { kind: 'text', text: decoded.text, truncated: decoded.truncated };
    }
    case 'csv': {
      const decoded = decodePreviewText(bytes);
      const table = parseDelimitedTable(decoded.text);
      return {
        kind: 'table',
        title: null,
        sheetCount: 1,
        rows: table.rows,
        truncated: decoded.truncated || table.truncated,
      };
    }
    case 'sheet': {
      const sheet = await readFirstSheet(bytes);
      return {
        kind: 'table',
        title: sheet.name,
        sheetCount: sheet.sheetCount,
        rows: sheet.rows,
        excelRows: sheet.excelRows,
        truncated: sheet.truncated,
      };
    }
    default: {
      const exhaustive: never = kind;
      return exhaustive;
    }
  }
}
